// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:17
import { EventNode_abstract } from './../abstract/SagaSchema/EventNode_abstract';
export class EventNode extends EventNode_abstract {}
